import React from 'react';

import { Organization, Service, WithContext } from 'schema-dts';

import { useCommonData } from '@stores/global-data';

import { contactPhone, formatRussianPhoneNumber } from '@utils/contacts';
import { APP_URL } from '@utils/env';
import { getOrganizationLogoUrl } from '@utils/seo';

import { SchemaScript } from '@components/common/SchemaOrg/SchemaScript';

export const HomeSchema: React.FC = () => {
    const {
        contacts: {
            header: { phone: headerPhone },
            footer: { phones: footerPhones },
        },
    } = useCommonData();

    const baseUrl = APP_URL;
    const logoUrl = getOrganizationLogoUrl(baseUrl);
    const phone = formatRussianPhoneNumber(headerPhone ?? footerPhones[0] ?? contactPhone);

    const organizationSchema: WithContext<Organization> = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Интернет-магазин и доставка продуктов Гурман-М',
        logo: logoUrl,
        url: baseUrl,
        telephone: phone,
        address: {
            '@type': 'PostalAddress',
            streetAddress: 'Русская, 94А',
            addressLocality: 'Владивосток',
            addressRegion: 'Приморский край',
            postalCode: '690105',
            addressCountry: 'RU',
        },
        sameAs: ['https://2gis.ru/vladivostok/firm/3518965489961527'],
    };

    const serviceSchema: WithContext<Service> = {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Доставка продуктов',
        provider: {
            '@type': 'Organization',
            name: organizationSchema.name,
            url: baseUrl,
        },
        description:
            'Доставка продуктов на дом, в кафе и рестораны из магазина Гурман-М. Бесплатная доставка продуктов по Владивостоку и Приморскому краю при заказе от 500 ₽. Мясо, птица, сыры, полуфабрикаты и бакалея премиального качества',
        areaServed: {
            '@type': 'AdministrativeArea',
            name: 'Приморский край, Владивосток',
        },
        serviceType: 'Доставка продуктов',
        availableChannel: {
            '@type': 'ServiceChannel',
            availableLanguage: 'Русский',
            serviceUrl: baseUrl,
            servicePhone: {
                '@type': 'ContactPoint',
                telephone: phone,
                contactType: 'Колл-центр',
            },
        },
    };

    return (
        <>
            <SchemaScript id="organization-schema" schema={organizationSchema} />
            <SchemaScript id="service-schema" schema={serviceSchema} />
        </>
    );
};
